export interface Testimonial {
  id: string;
  quote: string;
  author: string;
  authorTitle: string;
  image: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    quote: '关注911爆料网已经两年了，这里的猛料永远是全网最快的。很多明星塌房前一天，这里就已经有风声了。真正的吃瓜第一线，比微博还快！',
    author: '资深吃瓜人小王',
    authorTitle: '3年老用户',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20anonymous%20portrait%20silhouette%20in%20dark%20room%2C%20half%20face%20lit%20by%20phone%20screen%20glow%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20portrait%20photography%2C%20deep%20shadows%2C%20neutral%20gray%20background%2C%20mysterious%20mood%2C%20no%20identifiable%20features%2C%20clean%20composition&width=600&height=800&seq=testimonial-01&orientation=portrait',
  },
  {
    id: '2',
    quote: '作为一个自媒体人，911爆料网是我每天必刷的来源。很多选题灵感都来自这里，而且爆料的真实性相对较高，有图有真相，不是那种纯编故事。',
    author: '匿名投稿人L',
    authorTitle: '自媒体从业者',
    image: 'https://readdy.ai/api/search-image?query=Dark%20portrait%20of%20person%20holding%20camera%2C%20face%20hidden%20in%20shadow%2C%20dramatic%20side%20lighting%20from%20window%2C%20cinematic%20noir%20photography%2C%20neutral%20gray%20background%2C%20mysterious%20atmosphere%2C%20deep%20shadows%2C%20anonymous%20figure%2C%20clean%20composition&width=600&height=800&seq=testimonial-02&orientation=portrait',
  },
  {
    id: '3',
    quote: '在圈内混了这么多年，911爆料网是我见过最敢说的平台。很多料别的平台不敢发，这里直接上。虽然偶尔也有翻车的时候，但整体来说确实有真东西。',
    author: '圈内老炮X',
    authorTitle: '娱乐圈从业者',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20figure%20in%20dark%20suit%20leaning%20against%20wall%2C%20face%20obscured%20by%20shadow%2C%20dramatic%20overhead%20spotlight%2C%20film%20noir%20portrait%20style%2C%20deep%20contrast%2C%20neutral%20gray%20background%2C%20mysterious%20powerful%20presence%2C%20clean%20composition&width=600&height=800&seq=testimonial-03&orientation=portrait',
  },
];